import * as userApi from '@/api/user'

const actions = {
  async fetchProfile({ commit }) {
    const { data } = await userApi.getProfile()
    const user = data.data.user
    commit('auth/SET_USER', user, { root: true })
    return user
  },

  async updateProfile({ commit }, payload) {
    const { data } = await userApi.updateProfile(payload)
    commit('auth/SET_USER', data.data.user, { root: true })
    return data
  },

  async resetApiKey({ commit, rootGetters }) {
    const { data } = await userApi.resetApiKey()
    const current = rootGetters['auth/user']
    if (current) {
      commit('auth/SET_USER', { ...current, api_key: data.data.api_key }, { root: true })
    }
    return data
  },
}

export default {
  namespaced: true,
  actions,
}
